import {
  Component, ContentChildren, QueryList, OnDestroy,
  Output, EventEmitter, AfterContentChecked, Input
} from '@angular/core';
import {TileComponent} from "../tile/tile.component";

@Component({
  selector: 'mbnm-builder-tile-group',
  templateUrl: './tile-group.component.html',
  styleUrls: ['./tile-group.component.scss']
})
export class TileGroupComponent implements OnDestroy, AfterContentChecked {

  constructor( ) { }

  @ContentChildren(TileComponent) tiles: QueryList<TileComponent>;

  ngAfterContentChecked() {
    this.tiles.forEach( (tile:TileComponent, idx:number) => {
      // update showNotch value for each tile (only needs to happen once)
      tile.parent = this;
      if (this.initialSelectedIndex == idx) {
        setTimeout( () => {
          this.initialSelectedIndex = NaN;
          this.selectedTile = tile;
        }, 0);
      }
    });
  }

  @Input()
  initialSelectedIndex:number = NaN;

  @Output()
  selectedTileChanged: EventEmitter<any> = new EventEmitter<any>();

  private _selectedTile:TileComponent = null;
  public get selectedTile():TileComponent {
    return this._selectedTile;
  }

  public set selectedTile(val:TileComponent) {
    let oldValue = this._selectedTile;
    this._selectedTile = val;
    if (oldValue !== val) {
      if (this._selectedTile) {
        this._selectedTile.visited = true;
      }

      this.selectedTileChanged.emit({
        oldValue: oldValue,
        newValue: val
      });
    }
  }

  ngOnDestroy() {

  }
}
